export const currencyFormatterHelper = (value, minFraction = 2) => {
	if (value) {
		return value?.toLocaleString('en-US', {
			minimumFractionDigits: minFraction,
		});
	}
	return 0.0;
};
